<div class="login-bg">
	<div class="login-page">
  <div class="login-form">
    
    	<form [formGroup]="formGroup" (ngSubmit)="login()" class="form-container">
				<div class="title">
              <span>
                Log Masuk
              </span>

            </div>

					<div class="subheading">Sila masukkan emel dan kata laluan anda untuk menyemak permohonan pembaharuan kakitangan.</div>
						<div class="input-container">		
							<mat-form-field appearance="outline">
								<mat-label>Emel</mat-label>
								<input
									matInput
									required
									class="bold-input"
									formControlName="email"
									autocomplete="email"
								/>
								<mat-error>{{ "error.emailRequired" | translate }}</mat-error>
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>Kata laluan</mat-label>
								<input
									matInput
									class="bold-input"
									[type]="hide ? 'password' : 'text'"
									formControlName="password"
									required
								/>
								<button
									type="button"
									mat-icon-button
									matSuffix
									(click)="hide = !hide"
									[attr.aria-label]="'Hide password'"
									[attr.aria-pressed]="hide"
								>
									<mat-icon>{{
										hide ? "visibility_off" : "visibility"
									}}</mat-icon>
								</button>
								<mat-error>{{ "error.passRequired" | translate }}</mat-error>
							</mat-form-field>
							<div class="forgot-password-link">
								<span (click)="goToForgotPass()">
									Lupa kata laluan?
								</span>
							</div>
							<button
								mat-raised-button
								class="login-btn"
								[disabled]="formGroup.invalid"
								(click)="login()"
							>
								Log Masuk
							</button>			
						</div>
					
					</form>
  </div>
	<div class="crm-info">
			<img
				src="https://storage.googleapis.com/ps-asset/affiliate/landing/kopetro-banner_1-en.png"
				alt="mockup-1"
				style="width:100%"
			/>
		</div>
</div>

</div>
